module.exports = __webpack_public_path__ + "static/media/product_list_6.b468714d.png";